var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82373 22.5V21.2647C1.82373 16.4891 5.69515 12.6176 10.4708 12.6176C15.2464 12.6176 19.1178 16.4891 19.1178 21.2647V22.5",
    stroke: "#737791",
    strokeWidth: 1.85294,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6475 15.0882C16.6475 11.6771 19.4128 8.91177 22.8239 8.91177C26.2351 8.91177 29.0004 11.6771 29.0004 15.0882V15.7059",
    stroke: "#737791",
    strokeWidth: 1.85294,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.471 12.6176C13.1999 12.6176 15.4121 10.4054 15.4121 7.67647C15.4121 4.94753 13.1999 2.73529 10.471 2.73529C7.74202 2.73529 5.52979 4.94753 5.52979 7.67647C5.52979 10.4054 7.74202 12.6176 10.471 12.6176Z",
    stroke: "#737791",
    strokeWidth: 1.85294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8236 8.91176C24.8703 8.91176 26.5294 7.25258 26.5294 5.20588C26.5294 3.15919 24.8703 1.5 22.8236 1.5C20.7768 1.5 19.1177 3.15919 19.1177 5.20588C19.1177 7.25258 20.7768 8.91176 22.8236 8.91176Z",
    stroke: "#737791",
    strokeWidth: 1.85294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraders);
export default __webpack_public_path__ + "static/media/traders.e7d65392569924f13cf27fcdb578b184.svg";
export { ForwardRef as ReactComponent };